import React from 'react';
// NOTE: Javid, u can use this component to render current svgs
export type IconProps = {
	className?: string;
	color?: string;
	decorative?: boolean;
	onClick?: React.MouseEventHandler<SVGSVGElement>;
	onKeyDown?: React.KeyboardEventHandler<SVGSVGElement>;
	size?: number | string;
	style?: React.CSSProperties;
	tabIndex?: number;
	title?: string;
} & Omit<React.SVGProps<SVGSVGElement>, 'color'>;

type BaseProps = IconProps & { viewBox?: string };

export const IconBase = ({
	size = 20,
	color = 'currentColor',
	title,
	decorative = !title,
	className,
	style,
	children,
	onClick,
	onKeyDown,
	tabIndex,
	viewBox = '0 0 20 20',
	...restItems
}: BaseProps) => {
	const isInteractive = Boolean(onClick);
	const isDecorative = decorative ?? (!title && !isInteractive);
	const ariaProps: React.SVGProps<SVGSVGElement> =
		isDecorative && !isInteractive
			? { 'aria-hidden': true }
			: {
					role: isInteractive ? 'button' : 'img',
					...(title ? { 'aria-label': title } : {}),
				};

	const interactiveProps = isInteractive
		? {
				tabIndex: tabIndex ?? 0,
				onKeyDown: (e: React.KeyboardEvent<SVGSVGElement>) => {
					onKeyDown?.(e);
					if (e.defaultPrevented) return;

					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						(onClick as any)?.(e as unknown as React.MouseEvent<SVGSVGElement>);
					}
				},
			}
		: { onKeyDown, tabIndex };

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox={viewBox}
			fill="none"
			style={{ color, ...style }}
			onClick={onClick}
			className={className}
			{...ariaProps}
			{...interactiveProps}
			{...restItems}
		>
			{title ? <title>{title}</title> : null}
			{children}
		</svg>
	);
};
